export function clearTextFromNewLines(text: string): string {
    return text.replace(/[\u2028]/g, '');
}
